<template>
    <div class="page-table mainDiv projeTanim" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.projeler.tanimlama.pageBaslik")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="projeKategoriForm" :rules="rulesProjeKategori" ref="projeKategoriForm"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.projeler.tanimlama.baslik")'
                                                prop="baslik">:
                                            <div v-if="linkVisible" style="float: right; display: flex">
                                                <div v-if="!VisibleA">
                                                    <el-link target="_blank" :underline="false"
                                                             :href="this.path">
                                                        {{this.path}}{{this.projeKategoriForm.link}}
                                                    </el-link>
                                                </div>
                                                <el-button v-if="duzenleBtnVisible"
                                                           style="margin-left: 10px; margin-bottom: 5px"
                                                           v-on:click="VisibleA = true; duzenleBtnVisible=false"
                                                           size="mini">Düzenle
                                                </el-button>
                                                <span v-if="VisibleA">{{this.path}} </span>
                                                <el-input v-if="VisibleA" v-model="projeKategoriForm.link"
                                                          v-on:change="$store.commit('changeTabsClose', false);linkChange = false"
                                                          v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                          style="width: 50%" size="mini"></el-input>
                                            </div>
                                            <el-input
                                                    :disabled="disabled"
                                                    v-model="projeKategoriForm.baslik"
                                                    v-on:change="linkTespit();$store.commit('changeTabsClose', false);"
                                                    :placeholder='$t("src.views.apps.projeler.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.projeler.tanimlama.icerik")'
                                                      prop="icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="projeKategoriForm.icerik"
                                                      :disabled="disabled"
                                                      @input="$store.commit('changeTabsClose', false)"
                                                      @blur="$store.commit('changeTabsClose', false)"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane v-if="$store.state.dilDurum">
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.baslik")'
                                                      prop="dil.en.baslik">:
                                            <el-input
                                                    v-model="projeKategoriForm.dil.en.baslik"
                                                    v-on:change="$store.commit('changeTabsClose', false);projeKategoriForm.dil.en.seobaslik = projeKategoriForm.dil.en.baslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.icerik")'
                                                      prop="dil.en.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="projeKategoriForm.dil.en.icerik"
                                                      @input="$store.commit('changeTabsClose', false)"
                                                      @blur="$store.commit('changeTabsClose', false)"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-tab-pane>
                        <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                            <el-row>
                                <el-col :span="24">
                                    <draggable
                                            data-source="juju"
                                            class="list-group"
                                            group="a">
                                        <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="4">
                                            <el-row>
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <el-form-item
                                                            prop="image">
                                                        <el-upload
                                                                action=""
                                                                :auto-upload="false"
                                                                :limit="1"
                                                                :file-list="imageMain"
                                                                accept=".jpg,.jpeg,.png"
                                                                ref="upload"
                                                                list-type="picture-card"
                                                                :on-change="imageUpload"
                                                                :on-remove="imageRemove">
                                                            <i slot="default" class="el-icon-plus"></i>
                                                        </el-upload>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </el-collapse-item>
                                    </draggable>
                                </el-col>
                            </el-row>
                        </el-collapse>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
                        <el-collapse-item class="card-shadow--medium" name="1"
                                          :title='$t("src.views.apps.projeler.tanimlama.durum")'>
                            <el-row>
                                <el-button
                                        size="mini" v-on:click="projeKategoriDuzenle('projeKategoriForm')"
                                        class="onayBtn"
                                        type="primary">
                                    <label>Güncelle</label>
                                </el-button>
                            </el-row>
                        </el-collapse-item>
                        <draggable class="list-group" group="a">
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.projeler.tanimlama.kategori")' name="2">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.projeler.kategori.tanimlama.menu")'>:
                                            <el-select
                                                    v-model="projeKategoriForm.menu"
                                                    :placeholder='$t("src.views.apps.projeler.kategori.tanimlama.menuPlace")'
                                                    style="width: 100%">
                                                <el-option value="0" label="Gösterme">Gösterme</el-option>
                                                <el-option value="1" label="Göster">Göster</el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>
<script>
    import JQuery from 'jquery';
    import ClassicEditor from '../../../../../node_modules/ckeditor5-build-classic';
    import draggable from "vuedraggable";

    let $ = JQuery;
    import seoService from '../../../../WSProvider/SeoService'
    import controllerService from '../../../../WSProvider/ControllerService'
    import projeService from '../../../../WSProvider/ProjeService'
    import projeKategoriService from '../../../../WSProvider/ProjeKategoriService'
    import notification from '../../../../notification'

    let base64 = require('base64_js');
    let userDataEstas = "";
    export default {
        name: "KategoriDuzenle",
        components: {
            draggable
        },
        data() {
            return {
                path: projeService.path,
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr',
                },
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                VisibleA: false,
                visibleSil: false,
                duzenleBtnVisible: true,
                seoicerikIngChange: true,
                visibleWebSite: false,
                disabled: false,
                linkChange: true,
                linkVisible: false,
                imageMain: [],
                updateKategoriKodu: '',
                projeKategoriForm: {
                    baslik: '',
                    icerik: '',
                    link: '',
                    image: '',
                    menu: '0',
                    dil: {
                        en: {
                            baslik: '',
                            icerik: ''
                        }
                    }
                },
                rulesProjeKategori: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Proje Kategori Başlığı Giriniz",
                        trigger: 'blur'
                    }]
                },
            }
        },
        mounted() {
            this.updateKategoriKodu = this.$store.state.updateKodu;
            this.getProjeKategoriDetay(this.updateKategoriKodu);
        },
        methods: {
            linkTespitLink() {
                let self = this;
                if (this.projeKategoriForm.link) {
                    seoService.linkKontrol(self.projeKategoriForm.link.replace("'", "").substring(0, 60)).then((response) => {
                        if (response.status === 200) {
                            self.projeKategoriForm.link = response.data;
                        } else {
                            notification.Status(notification.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.projeKategoriForm.baslik && this.linkChange) {
                    seoService.linkKontrol(this.projeKategoriForm.baslik.replace("'", "").substring(0, 60)).then((response) => {
                        if (self.projeKategoriForm.baslik) {
                            if (response.status === 200) {
                                self.linkVisible = true;
                                self.projeKategoriForm.link = response.data;
                            }
                        } else if (!self.projeKategoriForm.baslik) {
                            self.linkVisible = false;
                            self.projeKategoriForm.link = '';
                        }
                    })
                }
            },
            getProjeKategoriDetay() {
                let self = this;
                projeKategoriService.kategoriDetay(this.updateKategoriKodu).then((response) => {
                    if (response.status === 200) {
                        self.projeKategoriForm.baslik = response.data.baslik;
                        self.linkVisible = true;
                        self.projeKategoriForm.link = response.data.link;
                        if (response.data.icerik) {
                            self.projeKategoriForm.icerik = htmlDecode(response.data.icerik);
                        }
                        if (response.data.resim) {
                            $('.el-upload--picture-card').hide();
                            this.imageMain.push({
                                name: response.data.resim,
                                url: projeKategoriService.imageUrlOrta + response.data.resim
                            });
                        }
                        self.projeKategoriForm.menu = response.data.menu;
                        if (self.$store.state.dilDurum) {
                            self.projeKategoriForm.dil.en.baslik = response.data.dil.en.baslik;
                            if (response.data.dil.en.icerik) {
                                self.projeKategoriForm.dil.en.icerik = htmlDecode(response.data.dil.en.icerik);
                            }
                        }

                    }
                })
            },
            imageUpload(file) {
                $('.el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.projeKategoriForm.baslik) {
                        var imgname = randomText(7) + '-' +linkTemizle(this.projeKategoriForm.baslik) + ".png";
                    } else {
                        imgname = randomText(7) + '-' +linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                    }
                    this.projeKategoriForm.image = imgname;
                    this.sumResimFonk(file,imgname)
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('projeKategori', imgname, data).then((response) => {
                            if (response.status === 200) {
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageRemove() {
                $('.el-upload--picture-card').show();
            },

            projeKategoriDuzenle(formName) {
                let dil = [];
                let self = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (self.$store.state.dilDurum) {
                            dil = {
                                en: {
                                    baslik: this.projeKategoriForm.dil.en.baslik,
                                    icerik: this.projeKategoriForm.dil.en.icerik,
                                },
                            };
                        }
                        projeKategoriService.kategoriGuncelle(this.updateKategoriKodu,this.projeKategoriForm.link, this.projeKategoriForm.baslik,
                            this.projeKategoriForm.icerik,this.projeKategoriForm.image,this.projeKategoriForm.menu, dil).then((response) => {
                            if (response.status === 200) {
                                notification.Status('success', this, 'Proje Kategori başarıyla eklendi.');
                                this.resetForm(formName);
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir proje zaten mevcut');

                            } else {
                                notification.Status(notification.status, this)
                            }
                        });
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.visibleSil = false;
                this.projeKategoriForm.link = null;
                this.linkVisible = false;
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "ProjeKategoriDuzenle");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "ProjeKategoriDuzenle") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
        }
    }

    function htmlDecode(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }
    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return bugun + "-" + text;
    }
</script>

<style scoped>

    .upload-demo ul {
        margin: 0;
        padding: 0;
        list-style: none;
        background: aliceblue;
        width: 50%;
    }

    .el-tag + .el-tag {
        margin-left: 10px;
    }


</style>